import type { ReactNode } from "react";

/** An empty state is an invitation to act: say what goes here and offer the next step. */
export function EmptyState({
  glyph = "🕯️",
  title,
  children,
  action,
}: {
  glyph?: string;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="hx-empty">
      <span className="hx-empty__glyph" aria-hidden="true">
        {glyph}
      </span>
      <h3>{title}</h3>
      {children && <p>{children}</p>}
      {action}
    </div>
  );
}

export function Spinner({ label = "Loading" }: { label?: string }) {
  return (
    <span role="status">
      <span className="hx-spinner" aria-hidden="true" />
      <span className="hx-sr-only">{label}</span>
    </span>
  );
}

/** A polite live region for status messages ("Saved", "Synced"). */
export function StatusMessage({ children }: { children?: ReactNode }) {
  return (
    <p
      role="status"
      aria-live="polite"
      className="hx-muted"
      style={{ minHeight: "1.5em", margin: 0 }}
    >
      {children}
    </p>
  );
}

export function Panel({
  as: Tag = "section",
  children,
  className,
  ...rest
}: {
  as?: "section" | "div" | "article" | "aside";
  children: ReactNode;
  className?: string;
} & Record<string, unknown>) {
  return (
    <Tag className={["hx-panel", className].filter(Boolean).join(" ")} {...rest}>
      {children}
    </Tag>
  );
}
